<div class="flex flex-col mt-2 pb-4">
  @for (group of navGroups(); track group.label) {
    <div class="mb-1">
      <p class="px-4 pt-3 pb-1.5 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
        {{ group.label }}
      </p>
      <div class="space-y-0.5 px-2">
        @for (item of group.items; track item.name) {
          <app-sidebar-navigation-button
            [icon]="item.icon"
            [name]="item.name"
            [link]="item.link"
          ></app-sidebar-navigation-button>
        }
      </div>
    </div>
  }
</div>
